










































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EditorWithFile from "@/components/EditorWithFile.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import Modal from "@/components/form/Modal.vue";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { Company as ICompany } from "@/api/models/company";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { User as IUser } from "@/api/models/user";
import { CourseCreate as ICourseCreate } from "@/api/models/course-create";
import { Course as ICourse } from "@/api/models/course";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { Category as ICategory } from "@/api/models/category";
import { CategoryList as ICategoryList } from "@/api/models/category-list";
import { Term as ITerm } from "@/api/models/term";
import { TermList as ITermList } from "@/api/models/term-list";
import { CourseDocumentInfoEdit as ICourseDocumentInfoEdit } from "@/api/models/course-document-info-edit";
import { CourseDocumentInfo as ICourseDocumentInfo } from "@/api/models/course-document-info";
import { CourseEdit as ICourseEdit } from "@/api/models/course-edit";
import {
  laborExportModule,
  learningDocumentsModule
} from "@/plugins/modules-detect";
import { getCurrentUserId, getCurrentCompanyId, isRoot } from "@/plugins/roles";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import professionalActivity from "@/getinfo-api/professionalActivity";
import professionalProrgamm from "@/getinfo-api/professionalProrgamm";
import termDocTypes from "@/getinfo-api/documentType";
import specialty from "@/getinfo-api/specialty";
import categories, { CategoriesListParams } from "@/getinfo-api/categories";
import { LearningMaterialLocales } from "@/plugins/custom-interface";
import api from "@/getinfo-api";
import { laborsList } from "@/utils/labor";

@Component({
  components: {
    Modal,
    CSingleSelect,
    CBlock,
    CField,
    CustomButton,
    EditorWithFile,
    SelectEntity
  }
})
export default class CourseForm extends Vue {
  @Prop() fisFRDO?: ICourseDocumentInfo;
  @Prop() course!: ICourse;
  title!: string | any;
  description!: string | any;
  enabled: boolean | any = true;
  price: number = 0;
  hours: number | any = 0;
  document!: string;
  validityOfDocument!: number | any;
  freeNavigation: boolean = true;
  companies!: Array<ICompany>;
  employeesList!: Array<IUser>;
  categoryList!: Array<ICategory>;
  ownerId!: string | any;
  categoryId!: string | any;
  termListActivity: Array<ITerm> = [];
  termListProgram: Array<ITerm> = [];
  termListSpeciality: Array<ITerm> = [];
  termDocTypes: Array<ITerm> = [];
  activityId?: string | undefined;
  programId?: string | undefined;
  specialityId?: string | undefined;
  qualification: string | undefined;
  isSavingProcess: boolean = false;
  documentTypeId?: string | undefined;
  locale: string = "";
  laborProtectionLearnProgram: number | undefined = 0;

  data() {
    return {
      title: "",
      description: "",
      ownerId: undefined,
      document: undefined,
      validityOfDocument: undefined,
      categoryId: undefined,
      companies: undefined,
      employeesList: undefined,
      categoryList: undefined,
      qualification: undefined,
      activityId: undefined,
      programId: undefined,
      specialityId: undefined,
      documentTypeId: undefined
    };
  }

  get labors() {
    return laborsList;
  }

  get learningDocuments() {
    return learningDocumentsModule();
  }

  get locales() {
    return LearningMaterialLocales();
  }

  getTaxonomy() {
    let params: any = {
      limit: 500
    };
    termDocTypes(params).then((res: { data: ITermList }) => {
      this.termDocTypes = [...this.termDocTypes, ...res.data.items];
    });

    professionalActivity(params).then((res: { data: ITermList }) => {
      this.termListActivity = [...this.termListActivity, ...res.data.items];
    });

    professionalProrgamm(params).then((res: { data: ITermList }) => {
      this.termListProgram = [...this.termListProgram, ...res.data.items];
    });

    specialty(params).then((res: { data: ITermList }) => {
      this.termListSpeciality = [...this.termListSpeciality, ...res.data.items];
    });
  }

  checkPrice(value: number) {
    return value <= 0 ? 0 : this.price;
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get laborModuleEnabled() {
    return laborExportModule();
  }

  getEmployee() {
    if (this.selectedCompanyId) {
      if (this.root || this.companyOwner) {
        let params: EmployeeListParams = {
          id: this.selectedCompanyId,
          roles: ["content_manager"],
          limit: 200
        };

        employee(params)
          .then((res: { data: IEmployeesList2 }) => {
            this.employeesList = [];
            if (res.data.employees.length) {
              res.data.employees.forEach(element => {
                this.employeesList.push(element.user);
              });
              this.ownerId = this.course
                ? this.course?.owner?.id
                : this.employeesList[0].id;
            }
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      } else {
        let params: EmployeeListParams = {
          id: this.selectedCompanyId,
          roles: ["content_manager"],
          limit: 200
        };

        employee(params)
          .then((res: { data: IEmployeesList2 }) => {
            this.employeesList = [];
            if (res.data.employees.length) {
              res.data.employees.forEach(element => {
                this.employeesList.push(element.user);
              });
              this.ownerId = getCurrentUserId();
            }
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      }
    }
  }

  @Watch("selectedCompanyId")
  updateSelectedCompany() {
    this.getEmployee();
  }

  @Watch("fisFRDO")
  updFisFRDO() {
    this.activityId = this.fisFRDO?.activity?.id;
    this.qualification = this.fisFRDO?.qualification;
    this.programId = this.fisFRDO?.program?.id;
    this.specialityId = this.fisFRDO?.specialty?.id;
    this.validityOfDocument = this.fisFRDO?.validityOfDocument;
    this.documentTypeId = this.fisFRDO?.documentType?.id;
  }

  @Watch("course")
  updCourse() {
    this.title = this.course?.title;
    this.description = this.course?.description;
    this.categoryId = this.course?.category?.id;
    this.hours = this.course?.hours;
    this.price = this.$converter.getPrice(this.course.price);
    this.ownerId = this.course?.owner.id;
    this.enabled = this.course?.enabled;
    this.freeNavigation = this.course?.freeNavigation;
    this.laborProtectionLearnProgram = this?.course?.laborProtectionLearnProgramId;
    this.locale = this.course?.locale ?? "";
  }

  created() {
    if (this.course) {
      this.updCourse();
      this.updFisFRDO();
    }
    this.getAllCategory();
    this.getEmployee();
    // this.getActivity();
    this.getTaxonomy();
  }

  formatterValidityOfDocument() {
    if (this.validityOfDocument < 0) {
      this.validityOfDocument = 0;
    }
  }
  get companyId(): string {
    return getCurrentCompanyId();
  }

  getAllCategory() {
    let params: CategoriesListParams = {
      companyId: this.companyId,
      limit: 600
    };
    categories(params)
      .then((res: { data: ICategoryList }) => {
        this.categoryList = res.data.items;
        if (res.data) {
          this.categoryId = !this.course
            ? res.data.items[0].id
            : this.course.category?.id;
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  async editCourseDocumentInfo() {
    let param: ICourseDocumentInfoEdit = {
      qualification: this.qualification,
      activityId: this.activityId,
      specialtyId: this.specialityId,
      validityOfDocument: this.validityOfDocument,
      documentTypeId: this.documentTypeId ? this.documentTypeId : undefined,
      programId: this.programId
    };
    await api.CourseApi.editDocumentInfo(this.course.id, param).catch(
      (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.isSavingProcess = false;
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      }
    );
  }

  async saveCourse() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    if (this.course || this.fisFRDO) {
      this.editCourse();
    } else {
      await this.createCourse();
    }
  }

  async createCourse() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    this.isSavingProcess = true;
    const courseInfo: ICourseCreate = {
      title: this.title,
      description: this.description,
      companyId: this.selectedCompanyId,
      ownerId: this.ownerId,
      enabled: this.enabled,
      price: this.$converter.setPrice(this.price),
      hours: this.hours ? this.hours : 0,
      categoryId: this.categoryId,
      freeNavigation: this.freeNavigation,
      laborProtectionLearnProgram: this.laborProtectionLearnProgram ?? 0,
      locale: this.locale ?? ""
    };

    api.CourseApi.create(courseInfo)
      .then(async (res: { data: ICourse }) => {
        let documentInfoParams: ICourseDocumentInfoEdit = {
          qualification: this.qualification,
          activityId: this.activityId,
          specialtyId: this.specialityId,
          validityOfDocument: this.validityOfDocument
            ? this.validityOfDocument
            : 0,
          documentTypeId: this.documentTypeId ? this.documentTypeId : undefined,
          programId: this.programId
        };

        await api.CourseApi.editDocumentInfo(res.data.id, documentInfoParams);
        await this.$router.push({
          name: "courses"
        });
      })
      .catch((error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
        if (error.response) {
          this.$bvToast.toast(error.response.data.message, {
            title: `${this.$tc(this.$translate.Error)}`,
            variant: "danger"
          });
        }
      })
      .finally(() => {
        this.isSavingProcess = false;
      });
  }

  async editCourse() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;

    this.isSavingProcess = true;
    await this.editCourseDocumentInfo();
    const courseInfoEdit: ICourseEdit = {
      title: this.title,
      description: this.description,
      ownerId: this.ownerId,
      price: this.$converter.setPrice(this.price),
      hours: this.hours,
      document: this.document,
      fileIds: this.course.files?.map(({ id }) => id),
      validityOfDocument: this.validityOfDocument,
      categoryId: this.categoryId,
      freeNavigation: this.freeNavigation,
      locale: this.locale ?? "",
      laborProtectionLearnProgram: this.laborProtectionLearnProgram ?? 0,
      enabled: this.enabled
    };
    await api.CourseApi.edit(this.$route.params.courseId, courseInfoEdit)
      .then(() => {
        this.$router.push({
          name: "courseView",
          params: { courseId: this.course.id }
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isSavingProcess = false;
      });
  }

  deleteCourse() {
    api.CourseApi._delete(this.course.id)
      .then(() => {
        this.$router.push({ name: "courses" });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
}
